/**
* Helper to check if a hostname is local.
*/
export function checkIsLocal (hostname) {
  return hostname === '127.0.0.1' || hostname === 'localhost'
}

/**
* Resolve API st_subdomain from the browser hostname.
* Master portal hosts (my, www, …) → www; account hosts (online, …) → account name.
*/
export function resolveLoginDomainFromHost () {
  const hostname = window.location.hostname
  if (checkIsLocal(hostname)) {
    return 'www'
  }

  const parts = window.location.href.split('.')
  let hostPart = parts[0]
  if (hostPart.includes('//')) hostPart = hostPart.split('//')[1]

  const onlyDomainReg = new RegExp(
    '\\b(' + (process.env.ONLY_DOMAIN_REGEX || 'www') + ')\\b'
  )
  if (onlyDomainReg.test(hostPart)) {
    return process.env.DEFAULT_DOMAIN || 'www'
  }
  return hostPart
}

/** True when URL is the Vue login SPA (/ or /{whitelabel}), not CakePHP (/my/…). */
export function isSpaLoginUrl (url) {
  try {
    const u = new URL(url, window.location.origin)
    const path = u.pathname.replace(/\/+$/, '') || '/'
    if (/\/my\//i.test(path)) return false
    if (/\/(admindashboard|dashboard|forms)\b/i.test(path)) return false
    const segments = path.split('/').filter(Boolean)
    return segments.length <= 1
  } catch {
    return false
  }
}

/**
* Use API REDIRECT_URL only when it targets CakePHP.
* Rewrites host to the current account subdomain so login on online.* stays on online.*.
* Returns null when API points at the Vue login page (causes my → cake double redirect).
*/
export function normalizePostLoginRedirect (apiUrl) {
  if (!apiUrl || typeof apiUrl !== 'string') return null
  if (isSpaLoginUrl(apiUrl)) return null

  try {
    const u = new URL(apiUrl, window.location.origin)
    const hostname = window.location.hostname
    if (checkIsLocal(hostname)) {
      u.protocol = window.location.protocol
      u.hostname = '127.0.0.1'
      u.port = '80'
    } else {
      u.protocol = window.location.protocol
      u.host = window.location.host
    }
    return u.href
  } catch {
    return null
  }
}

export function buildCakeDashboardUrl ({ whitelabel, userType, redirectPath }) {
  const hostname = window.location.hostname
  let host = window.location.host
  if (checkIsLocal(hostname)) {
    host = '127.0.0.1'
  }
  const base = window.location.protocol + '//' + host
  const dashboardPath =
    redirectPath != null
      ? redirectPath
      : (userType == 1 ? process.env.CAKE_ADMIN_PATH : process.env.CAKE_PATH)
  return base + (process.env.CAKE_BASE_PATH || '/my/') + (whitelabel || '') + dashboardPath
}
 
